import { FunctionComponent, useState } from 'react';
import { Form, Formik } from 'formik';
import { bool, object, string } from 'yup';
import toast, { Toaster } from 'react-hot-toast';

import { Button, Checkbox, Text, Textinput } from '@/atoms';

import { ButtonVariant } from '../hero/childs/types';

import { TypeRegisterFormProps, TypeRegisterProps } from './types';
import { Close } from '@/icons';
import { gtmPush } from '@/utils';

/**
 * Register
 */
export const Register: FunctionComponent<TypeRegisterProps> = ({
  className = '',
  title,
  backgroundColor,
  textButton,
  nameLabel,
  lastNameLabel,
  emailLabel,
  passwordLabel,
  labelCkeckDown,
  children,
}: TypeRegisterProps) => {
  const RegisterSchema = object().shape({
    firstName: string()
      .required('El nombre es obligatorio')
      .min(2, 'Too Short!')
      .max(50, 'Too Long'),
    lastName: string().min(2, 'Too Short!').max(100, 'Too Long'),
    email: string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long')
      .required('El email es Obligatorio'),
    password: string().required('La constraseña es obligatorio'),
    confirmPassword: string().required(
      'Confirmar la constraseña es obligatorio'
    ),
    politica: bool().required(),
    informacion: bool().required(),
  });
  const initialValues: TypeRegisterFormProps = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    politica: false,
    informacion: false,
  };
  // const socialMedias = [
  //   { Icon: Facebook, href: '#' },
  //   { Icon: Google, href: '#' },
  //   { Icon: Twitter, href: '#' },
  // ];
  const error = () =>
    toast('Ha habido un error, vuelve a intertarlo por favor.', {
      icon: (
        <Close
          width={64}
          color="#fff"
          className="p-3 rounded-full bg-tertiary-500 font-bold"
        />
      ),
      duration: 2000,
      style: {
        background: '#ffa59c',
        padding: '16px',
        fontWeight: 'bold',
        marginBottom: '80px',
        color: '#fff',
      },
    });
  const [valuePolitica, setValuePolitica] = useState(false);
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={`flex flex-col ${className}`}
    >
      <Text className="text-subtitle text-subtitle--l mb-6">{title}</Text>
      <Formik
        onSubmit={async (res: TypeRegisterFormProps) => {
          const response = await fetch('/api/shopify/customer/register', {
            method: 'POST',
            headers: {
              Accept: 'application.json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              firstName: res.firstName,
              lastName: res.lastName,
              email: res.email,
              password: res.password,
              acceptsMarketing: res.informacion,
            }),
            cache: 'default',
          });
          const data = await response.json();

          if (data.error && data.error !== '') {
            gtmPush({
              event: 'error',
              evento_asociado: 'sign_up',
              descripcion: 'Error en la plataforma shopify',
            });
            error();
          }

          if (
            data.data.customerCreate &&
            data.data.customerCreate.customerUserErrors &&
            data.data.customerCreate.customerUserErrors.length > 0
          ) {
            gtmPush({
              event: 'error',
              evento_asociado: 'sign_up',
              descripcion:
                data.data.customerCreate.customerUserErrors[0].message,
            });
            toast(data.data.customerCreate.customerUserErrors[0].message, {
              icon: (
                <Close
                  width={64}
                  color="#fff"
                  className="p-3 rounded-full bg-tertiary-500 font-bold"
                />
              ),
              duration: 2000,
              style: {
                background: '#ffa59c',
                padding: '16px',
                fontWeight: 'bold',
                marginBottom: '80px',
                color: '#fff',
              },
            });
          } else {
            gtmPush({
              event: 'sign_up',
              method: 'email',
              user_id: res.email,
            });
            gtmPush({
              event: 'join_group',
              group_id: 'registrado',
            });
            window.location.href = '/es/login';
          }
        }}
        validationSchema={RegisterSchema}
        initialValues={initialValues}
      >
        <Form noValidate>
          <div className="flex flex-wrap justify-between">
            <Textinput
              label={nameLabel}
              name="firstName"
              className="mb-2 w-full md:min-w-[300px]"
              placeholder="nombre"
            />
            <Textinput
              label={lastNameLabel}
              name="lastName"
              className="mb-2 w-full md:min-w-[300px]"
              placeholder="apellidos"
            />
            <Textinput
              label={emailLabel}
              name="email"
              type="email"
              className="mb-2 w-full md:min-w-[300px]"
              placeholder="ejemplo@gmail.com"
            />
            <Textinput
              label={passwordLabel}
              name="password"
              type="password"
              className="mb-2 w-full md:min-w-[300px]"
              placeholder="**********"
            />
            <Textinput
              label="Confirmación de constraseña*"
              name="confirmPassword"
              type="password"
              className="mb-2 w-full md:min-w-[300px]"
              placeholder="**********"
            />
            <div>
              <div className="mb-3">
                <Checkbox
                  name="politica"
                  value="acepto-politica"
                  id="politica"
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  checked={valuePolitica}
                  onChange={(event) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setValuePolitica(event.target.checked);
                  }}
                >
                  {children}
                </Checkbox>
              </div>
              <div className="mb-6">
                <Checkbox name="informacion" value="acepto-informacion">
                  {labelCkeckDown}
                </Checkbox>
              </div>
              <Button
                variant={ButtonVariant.PRIMARY}
                disabled={!valuePolitica}
                type="submit"
              >
                {textButton}
              </Button>
            </div>

            <Toaster
              position="bottom-center"
              containerStyle={{ position: 'absolute' }}
            />

            {/* <hr className="w-full h-[1px] my-6 text-secondary-200" />
            <div>
              <Text className="text-subtitle text-subtitle--m">{title2}</Text>
              <SocialMedia
                title=""
                socialMedias={socialMedias}
                position="start"
                className="my-6"
              />
            </div> */}
          </div>
        </Form>
      </Formik>
    </div>
  );
};
Register.displayName = 'Register';
